var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-box"},[_c('div',{staticClass:"mySwiper"},[_c('ul',{staticClass:"swiper-wrapper"},_vm._l((_vm.imgList),function(item,idxs){return _c('li',{key:idxs,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":require('@/assets/images/brand/' + item),"alt":""}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }